import { createElementVNode as _createElementVNode, normalizeClass as _normalizeClass, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
  return _openBlock(), _createElementBlock("div", {
    class: _normalizeClass(["toggle", [{
      'active': _ctx.modelValue
    }, {
      'loading': $props.loading
    }]])
  }, _cache[0] || (_cache[0] = [_createElementVNode("div", {
    class: "mark in-[.loading]:animate-spin"
  }, null, -1)]), 2);
}